import React from 'react';
import { Outlet } from 'react-router-dom';
import { UnifiedHeader } from '../components';

type AppShellProps = {
  showNav?: boolean;
};

export default function AppShell({ showNav = true }: AppShellProps) {
  return (
    <div className="min-h-screen bg-surfaceAlt text-ink flex flex-col">
      <UnifiedHeader showNav={showNav} />
      <Outlet />
    </div>
  );
}
